import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ReferenceState } from './reference.reducer';

export const selectReferenceState =
  createFeatureSelector<ReferenceState>('reference');

// Print Sites
export const selectPrintSites = createSelector(
  selectReferenceState,
  state => state.printSites
);

export const selectActivePrintSites = createSelector(selectPrintSites, sites =>
  sites.filter(site => site.isActive)
);

export const selectPrintSitesLoading = createSelector(
  selectReferenceState,
  state => state.printSitesLoading
);

export const selectPrintSitesLoaded = createSelector(
  selectReferenceState,
  state => state.printSitesLoaded
);

// Customer Types
export const selectCustomerTypes = createSelector(
  selectReferenceState,
  state => state.customerTypes
);

export const selectActiveCustomerTypes = createSelector(
  selectCustomerTypes,
  types => types.filter(type => type.isActive)
);

export const selectCustomerTypesLoading = createSelector(
  selectReferenceState,
  state => state.customerTypesLoading
);

export const selectCustomerTypesLoaded = createSelector(
  selectReferenceState,
  state => state.customerTypesLoaded
);

// Check Layouts
export const selectCheckLayouts = createSelector(
  selectReferenceState,
  state => state.checkLayouts
);

export const selectActiveCheckLayouts = createSelector(
  selectCheckLayouts,
  layouts => layouts.filter(layout => layout.isActive)
);

export const selectCheckLayoutsLoading = createSelector(
  selectReferenceState,
  state => state.checkLayoutsLoading
);

export const selectCheckLayoutsLoaded = createSelector(
  selectReferenceState,
  state => state.checkLayoutsLoaded
);

// Combined
export const selectAllReferenceDataLoaded = createSelector(
  selectPrintSitesLoaded,
  selectCustomerTypesLoaded,
  selectCheckLayoutsLoaded,
  (printSites, customerTypes, checkLayouts) =>
    printSites && customerTypes && checkLayouts
);

export const selectAnyReferenceDataLoading = createSelector(
  selectPrintSitesLoading,
  selectCustomerTypesLoading,
  selectCheckLayoutsLoading,
  (printSites, customerTypes, checkLayouts) =>
    printSites || customerTypes || checkLayouts
);

export const selectReferenceError = createSelector(
  selectReferenceState,
  state => state.error
);
